import { usePromo } from '../../hooks/promo/usePromo'
import { ImageModal } from './ImageModal'

export const PopupMain = () => {
    const { externalPopup, externalPromosLoaded } = usePromo()

    const apiPu = externalPromosLoaded && externalPopup
        && externalPopup.desktop_url?.trim() && externalPopup.mobile_url?.trim()
        ? externalPopup : null

    if (!apiPu) return null

    return (
        <div className="container">
            <ImageModal
                key={`api-popup-${apiPu.id}`}
                cookieName={`external-promo-${apiPu.id}`}
                desktopImg={apiPu.desktop_url}
                mobileImg={apiPu.mobile_url}
                link={apiPu.link?.trim() || undefined}
                endDate={apiPu.end_date ? String(apiPu.end_date).slice(0, 10) : undefined}
                name={apiPu.title?.trim() || `popup-${apiPu.id}`}
            />
        </div>
    )
}